import React, { useCallback, useEffect, useRef, useState } from 'react';
// import eventBus from '../EventBus';
import { motion } from 'framer-motion';
import UIEventBus from '../EventBus';
import { isMobilePreview } from '../mobile';

const HELP_TEXT_DESKTOP = "Cliquez n'importe où pour commencer";
// Sur tactile, « cliquez » est faux et le geste ne mene pas au meme endroit :
// il quitte la scene pour le site marketing, concu pour ces ecrans.
const HELP_TEXT_MOBILE = "Touchez n'importe où pour commencer";

type HelpPromptProps = {};

const HelpPrompt: React.FC<HelpPromptProps> = () => {
    const [helpText, setHelpText] = useState('');
    const [visible, setVisible] = useState(true);
    const visRef = useRef(visible);
    // Fige au montage : une rotation de tablette en pleine intro ne doit pas
    // changer le libelle ni la destination du geste en cours de route.
    const mobileRef = useRef(isMobilePreview());
    const startedRef = useRef(false);
    const fullText = mobileRef.current ? HELP_TEXT_MOBILE : HELP_TEXT_DESKTOP;

    const typeHelpText = (i: number, curText: string) => {
        if (i < fullText.length && visRef.current) {
            setTimeout(() => {
                window.postMessage(
                    { type: 'keydown', key: `_AUTO_${fullText[i]}` },
                    '*'
                );

                setHelpText(curText + fullText[i]);
                typeHelpText(i + 1, curText + fullText[i]);
            }, Math.random() * 120 + 50);
        }
    };

    // make a document listener to listen to clicks

    useEffect(() => {
        setTimeout(() => {
            typeHelpText(0, '');
        }, 500);

        const onStart = () => {
            setVisible(false);

            if (!mobileRef.current) return;

            // Un second appui relancerait le zoom et repousserait la
            // redirection d'autant.
            if (startedRef.current) return;
            startedRef.current = true;

            // Mobile et tablette : le geste de depart lance le zoom vers le
            // moniteur, comme au bureau ; c'est la Camera qui part sur le
            // site marketing quand l'ecran remplit le cadre. La redirection
            // se declenchait ici, sans transition.
            UIEventBus.dispatch('mobileEnterSite', {});
        };

        // pointerdown couvre la souris ET le tactile : mousedown seul ne se
        // declenchait jamais au doigt, donc le libelle restait affiche et la
        // scene ne demarrait pas sur telephone.
        document.addEventListener('pointerdown', onStart);
        UIEventBus.on('enterMonitor', () => {
            setVisible(false);
        });

        return () => {
            document.removeEventListener('pointerdown', onStart);
        };
    }, []);

    useEffect(() => {
        if (visible == false) {
            window.postMessage({ type: 'keydown', key: `_AUTO_` }, '*');
        }
        visRef.current = visible;
    }, [visible]);

    return helpText.length > 0 ? (
        <motion.div
            variants={vars}
            animate={visible ? 'visible' : 'hide'}
            style={styles.container}
        >
            <p style={{ color: '#0a1730', margin: 0 }}>{helpText}</p>
            <div style={styles.blinkingContainer}>
                <div className="blinking-cursor" />
            </div>
        </motion.div>
    ) : (
        <></>
    );
};

const vars = {
    visible: {
        opacity: 1,
    },
    hide: {
        y: 12,
        opacity: 0,
        transition: {
            duration: 0.5,
            ease: 'easeOut',
        },
    },
};

const styles: StyleSheetCSS = {
    container: {
        position: 'absolute',
        bottom: 64,
        // Fond blanc, texte navy et liseret teal : la couleur du texte est
        // posee ici plutot que de dependre de la regle globale sur <p>. Si
        // cette regle change, le libelle ne risque pas de devenir blanc sur
        // blanc, ce qui le rendait illisible.
        background: '#ffffff',
        color: '#0a1730',
        borderBottom: '2px solid #12c2b0',
        borderRadius: 2,
        padding: 4,
        paddingLeft: 16,
        paddingRight: 16,
        textAlign: 'center',
        display: 'flex',
        alignItems: 'flex-end',
        boxShadow: '0 6px 24px rgba(10, 23, 48, 0.25)',
    },
    blinkingContainer: {
        // width: 100,
        // height: 100,
        marginLeft: 8,
        paddingBottom: 2,
        paddingRight: 4,
    },
};

export default HelpPrompt;
